import React from 'react';
import { componentService } from 'js/services/component.service';

export const TwoFactorAuthenticationPreferences = React.lazy(() => import(/* webpackChunkName: "two-factor-preferences" */ './TwoFactorAuthenticationPreferences'));

// <hub2-two-factor-authentication-preferences> </hub2-two-factor-authentication-preferences>
componentService.registerWebContentComponents({ TwoFactorAuthenticationPreferences });
